module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sm-b6596da79cb2344618783d63bced1d40.svg";